import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Container,
  Row,
  Col,
  Button,
  Input,
  Label,
  Offcanvas,
  OffcanvasBody,
  OffcanvasHeader,
  Modal,
  ModalHeader,
  ModalBody
} from "reactstrap";

import { FaTrash } from "react-icons/fa";

import api from "../../utills/api";
import BreadCrumb from "../../Components/Common/BreadCrumb";

const MenuBuilder = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  // ==============================
  // CATEGORY MODAL
  // ==============================
  const [categoryModalOpen, setCategoryModalOpen] = useState(false);
  const [newCategory, setNewCategory] = useState("");
  const [categoryLoading, setCategoryLoading] = useState(false);

  const [menuItems, setMenuItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [inventory, setInventory] = useState([]);
  const [menuGroup, setMenuGroup] = useState("restaurant");

  const [form, setForm] = useState({
    name: "",
    category: "",
    description: "",
    status: "Active",
    imageUrl: "",
    ingredients: [],
    priceFull: "",
    priceHalf: "",
    preparationTime: "",

    sizes: [],
    bottleCost: "",
    shotSizeML: "",
    overheadCost: 100,

    menuGroup: ""
  });


  /* ================= FETCH DATA ================= */

  useEffect(() => {
    fetchMenuItems();
    fetchInventory();
  }, []);

  useEffect(() => {
    fetchCategories(menuGroup);

    // reset selected category when switching
    setForm(f => ({
      ...f,
      category: ""
    }));
  }, [menuGroup]);

const fetchCategories = async (group = menuGroup) => {
  try {
    const url =
      group === "restaurant"
        ? "/menu/menu-settings"
        : "/bar/bar-settings";

    const res = await api.get(url);

    setCategories(res.data || []);
  } catch (err) {
    console.error("Failed to load categories:", err);
    alert("Failed to load categories");
  }
};

const handleCreateCategory = async () => {
  if (!newCategory.trim()) {
    alert(
      `Enter ${menuGroup === "restaurant" ? "restaurant" : "bar"} category name`
    );
    return;
  }

  setCategoryLoading(true);

  try {
    const API_PATH =
      menuGroup === "restaurant"
        ? "api/menu/menu-settings"
        : "api/bar/bar-settings";

    const res = await api.post(API_PATH, {
      name: newCategory.trim()
    });

    // Add newly created category to current list
    setCategories((prev) => [res.data, ...prev]);

    // Clear input
    setNewCategory("");

    // Also refresh categories from backend
    await fetchCategories(menuGroup);

    alert("Category created successfully");

  } catch (err) {
    console.error("Category creation failed:", err);

    alert(
      err.response?.data?.message ||
      "Error creating category"
    );
  } finally {
    setCategoryLoading(false);
  }
};

const handleDeleteCategory = async (id) => {
  if (!window.confirm("Delete this category?")) {
    return;
  }

  try {
    const API_PATH =
      menuGroup === "restaurant"
        ? "api/menu/menu-settings"
        : "api/bar/bar-settings";

    await api.delete(`${API_PATH}/${id}`);

    setCategories((prev) =>
      prev.filter((item) => item._id !== id)
    );

  } catch (err) {
    console.error("Category delete failed:", err);

    alert(
      err.response?.data?.message ||
      "Failed to delete category"
    );
  }
};

const renderCategoryModal = () => {
  return (
    <Modal
      isOpen={categoryModalOpen}
      toggle={() => setCategoryModalOpen(false)}
      centered
      size="lg"
    >
      <ModalHeader
        toggle={() => setCategoryModalOpen(false)}
      >
        Create Category
      </ModalHeader>

      <ModalBody>

        {/* ==============================
            MENU GROUP TOGGLE
        ============================== */}

        <div className="d-flex justify-content-center mb-4">
          <div
            style={{
              background: "#f1f3f5",
              borderRadius: 40,
              padding: 4,
              display: "flex",
              gap: 4
            }}
          >

            <button
              type="button"
              onClick={() => {
                setMenuGroup("restaurant");
                setNewCategory("");
                fetchCategories("restaurant");
              }}
              className="border-0"
              style={{
                borderRadius: 30,
                padding: "7px 20px",
                fontWeight: 600,
                background:
                  menuGroup === "restaurant"
                    ? "#0d6efd"
                    : "transparent",
                color:
                  menuGroup === "restaurant"
                    ? "#fff"
                    : "#333"
              }}
            >
              🍽 Restaurant
            </button>

            <button
              type="button"
              onClick={() => {
                setMenuGroup("bar");
                setNewCategory("");
                fetchCategories("bar");
              }}
              className="border-0"
              style={{
                borderRadius: 30,
                padding: "7px 20px",
                fontWeight: 600,
                background:
                  menuGroup === "bar"
                    ? "#0d6efd"
                    : "transparent",
                color:
                  menuGroup === "bar"
                    ? "#fff"
                    : "#333"
              }}
            >
              🍺 Bar
            </button>

          </div>
        </div>


        {/* ==============================
            CREATE CATEGORY
        ============================== */}

        <Card className="border bg-light mb-4">
          <CardBody>

            <h6 className="mb-3">
              Create{" "}
              {menuGroup === "restaurant"
                ? "Restaurant"
                : "Bar"}{" "}
              Category
            </h6>

            <Row className="g-2">

              <Col md={9}>
                <Input
                  type="text"
                  placeholder={`Enter ${
                    menuGroup === "restaurant"
                      ? "restaurant"
                      : "bar"
                  } category name`}
                  value={newCategory}
                  onChange={(e) =>
                    setNewCategory(e.target.value)
                  }
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleCreateCategory();
                    }
                  }}
                />
              </Col>

              <Col md={3}>
                <Button
                  color="success"
                  className="w-100"
                  onClick={handleCreateCategory}
                  disabled={categoryLoading}
                >
                  {categoryLoading
                    ? "Creating..."
                    : "Create Category"}
                </Button>
              </Col>

            </Row>

          </CardBody>
        </Card>


        {/* ==============================
            CATEGORY LIST
        ============================== */}

        <Card className="border">
          <CardBody>

            <div className="d-flex justify-content-between align-items-center mb-3">

              <h6 className="mb-0">
                {menuGroup === "restaurant"
                  ? "Restaurant"
                  : "Bar"}{" "}
                Categories
              </h6>

              <span className="badge bg-primary">
                {categories.length}
              </span>

            </div>


            {categories.length === 0 ? (

              <div className="text-center py-4">
                <p className="text-muted mb-0">
                  No categories found
                </p>
              </div>

            ) : (

              <Row className="g-3">

                {categories.map((item) => (

                  <Col
                    key={item._id}
                    xs={12}
                    sm={6}
                    md={4}
                  >

                    <div
                      className="border rounded p-2 d-flex align-items-center justify-content-between"
                    >

                      <span className="fw-medium">
                        {item.name}
                      </span>

                      <Button
                        color="link"
                        className="p-0 text-danger"
                        onClick={() =>
                          handleDeleteCategory(item._id)
                        }
                      >
                        <FaTrash />
                      </Button>

                    </div>

                  </Col>

                ))}

              </Row>

            )}

          </CardBody>
        </Card>

      </ModalBody>
    </Modal>
  );
};

  const fetchInventory = async () => {
    try {
      const res = await api.get("/products");
      setInventory(res.data || []);
    } catch (err) {
      console.error("Inventory fetch failed", err);
      // ❌ remove alert (bad UX on page load)
    }
  };

  const fetchMenuItems = async () => {
    try {
      const res = await api.get("/menu-items");
      setMenuItems(res.data || []);
    } catch (err) {
      console.error(err);
      alert("Failed to load menu items");
    }
  };

  /* ================= SAVE ITEM ================= */
  const handleSave = async () => {
    try {

      const payload = {
        ...form,
        menuGroup,

        category: form.category || undefined,

        priceFull:
          menuGroup === "restaurant"
            ? Number(form.priceFull || 0)
            : undefined,

        priceHalf:
          menuGroup === "restaurant"
            ? Number(form.priceHalf || 0)
            : undefined,

        ingredients:
          menuGroup === "restaurant"
            ? form.ingredients
            : [],

        preparationTime:
          menuGroup === "restaurant"
            ? Number(form.preparationTime || 0)
            : undefined,

        sizes:
          menuGroup === "bar"
            ? form.sizes.map(s => ({
              size: s.size,
              price: Number(s.price)
            }))
            : [],

        // ✅ ADD THESE HERE — BAR CALC INPUTS
        bottleCost:
          menuGroup === "bar" ? Number(form.bottleCost) : undefined,

        shotSizeML:
          menuGroup === "bar" ? Number(form.shotSizeML) : undefined,

        overheadCost:
          menuGroup === "bar" ? Number(form.overheadCost) : undefined
      };

      let res;

      if (form._id) {
        res = await api.put(`/menu-items/${form._id}`, payload);
        setMenuItems(menuItems.map(i =>
          i._id === res.data._id ? res.data : i
        ));
      } else {
        res = await api.post("/menu-items", payload);
        setMenuItems(prev => [res.data, ...prev]);
      }

      setDrawerOpen(false);
      resetForm();

    } catch (err) {
      console.error(err);
      alert("Failed to save menu item");
    }
  };


  const addBarSize = () => {
    setForm({
      ...form,
      sizes: [...(form.sizes || []), { size: "", price: "" }]
    });
  };

  const updateBarSize = (idx, field, value) => {
    const copy = [...form.sizes];
    copy[idx][field] = value;
    setForm({ ...form, sizes: copy });
  };

  const removeBarSize = (idx) => {
    const copy = [...form.sizes];
    copy.splice(idx, 1);
    setForm({ ...form, sizes: copy });
  };

  const resetForm = () => {
    setForm({
      name: "",
      category: "",
      description: "",
      status: "Active",
      imageUrl: "",
      ingredients: [],
      priceFull: "",
      priceHalf: "",
      sizes: [],

      // ✅ BAR
      bottleCost: "",
      shotSizeML: "",
      overheadCost: 100,

      type: "",
      menuGroup
    });
  };

  /* ================= edit ================= */

  const handleEdit = (item) => {

    setMenuGroup(item.menuGroup || "restaurant");

    setForm({
      _id: item._id,
      name: item.name,
      category: item.category?._id || "",
      description: item.description,
      status: item.status,
      imageUrl: item.imageUrl,
      type: item.type,
      priceFull: item.priceFull,
      priceHalf: item.priceHalf,
      menuGroup: item.menuGroup,
      sizes: item.sizes || [],

      // ✅ ADD THESE
      bottleCost: item.bottleCost || "",
      shotSizeML: item.shotSizeML || "",
      overheadCost: item.overheadCost || 100,

      ingredients: (item.ingredients || []).map(ing => ({
        inventoryId:
          typeof ing.inventoryId === "object"
            ? ing.inventoryId._id
            : ing.inventoryId,
        qty: ing.qty
      }))
    });


    setDrawerOpen(true);
  };

  /* ================= DELETE ITEM ================= */
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this menu item?")) return;

    try {
      await api.delete(`api/menu-items/${id}`);
      setMenuItems(menuItems.filter((item) => item._id !== id));
    } catch (err) {
      console.error(err);
      alert("Failed to delete menu item");
    }
  };

  /* ================= BAR LIVE PREVIEW ================= */

  const barPreview = React.useMemo(() => {
    if (menuGroup !== "bar") return null;

    const bottleSizeML = 750;
    const shotSize = Number(form.shotSizeML);
    const bottleCost = Number(form.bottleCost);
    const overhead = Number(form.overheadCost || 100);

    const shotPrice = Number(form.sizes?.[0]?.price);

    if (!shotSize || !shotPrice || !bottleCost) return null;

    const shots = bottleSizeML / shotSize;
    const revenue = shots * shotPrice;
    const totalCost = bottleCost + overhead;
    const margin = revenue - totalCost;

    return {
      shots: shots.toFixed(2),
      revenue: revenue.toFixed(0),
      cost: totalCost.toFixed(0),
      margin: margin.toFixed(0)
    };
  }, [menuGroup, form.shotSizeML, form.bottleCost, form.overheadCost, form.sizes]);


  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Menu" pageTitle="Restaurant" />
        <Card className="border">
          <CardHeader className="bg-white border-bottom d-flex align-items-center position-relative">

            <h5 className="mb-0">Menu Items</h5>

            {/* CENTER: SEGMENT TOGGLE */}
            <div
              className="position-absolute start-50 translate-middle-x"
              style={{
                background: "#f1f3f5",
                borderRadius: 40,
                padding: 4,
                display: "flex",
                gap: 4
              }}
            >
              <button
                onClick={() => setMenuGroup("restaurant")}
                className="border-0"
                style={{
                  borderRadius: 30,
                  padding: "6px 16px",
                  fontWeight: 600,
                  background: menuGroup === "restaurant" ? "#0d6efd" : "transparent",
                  color: menuGroup === "restaurant" ? "#fff" : "#333"
                }}
              >
                🍽 Restaurant
              </button>

              <button
                onClick={() => setMenuGroup("bar")}
                className="border-0"
                style={{
                  borderRadius: 30,
                  padding: "6px 16px",
                  fontWeight: 600,
                  background: menuGroup === "bar" ? "#0d6efd" : "transparent",
                  color: menuGroup === "bar" ? "#fff" : "#333"
                }}
              >
                🍺 Bar
              </button>
            </div>

            {/* RIGHT: BUTTON */}
        {/* RIGHT: ACTION BUTTONS */}
<div className="ms-auto d-flex gap-2">

  {/* CREATE CATEGORY */}
  <Button
    color="success"
    onClick={() => {
      setNewCategory("");
      fetchCategories(menuGroup);
      setCategoryModalOpen(true);
    }}
  >
    <i className="ri-add-line me-1"></i>
    Create Category
  </Button>

  {/* BUILD MENU */}
  <Button
    color="primary"
    onClick={() => {
      resetForm();
      setForm(f => ({
        ...f,
        menuGroup
      }));
      setDrawerOpen(true);
    }}
  >
    <i className="ri-restaurant-line me-1"></i>
    Build Menu
  </Button>

</div>

          </CardHeader>

          <CardBody>
            {menuItems.length === 0 ? (
              <div className="text-center py-5">
                <h4>Build your own menu</h4>
                <p className="text-muted mb-3">
                  Add items with category, pricing and availability to create
                  your restaurant menu.
                </p>
                <Button color="primary" onClick={() => {
                  resetForm();
                  setForm(f => ({ ...f, menuGroup }));
                  setDrawerOpen(true);
                }}
                >
                  Build Menu
                </Button>
              </div>
            ) : (
              <Row>
                {menuItems
                  .filter(i => i && (i.menuGroup || "restaurant") === menuGroup)
                  .map((item) => (

                    <Col xxl={3} md={4} sm={6} key={item._id}>
                      <Card className="border h-100">
                        <CardBody>
                          <h6 className="mb-2">{item.name}</h6>

                          {/* <span className="badge bg-info mb-2">
    {(item.menuGroup || "restaurant").toUpperCase()}
  </span> */}

                          <img
                            src={
                              item.imageUrl ||
                              "https://via.placeholder.com/300x180?text=Food+Image"
                            }
                            alt="menu"
                            className="img-fluid rounded mb-3"
                            style={{
                              height: 160,
                              objectFit: "cover",
                              width: "100%"
                            }}
                          />
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <span className="text-muted small">
                              {item.category?.name} • {item.type}
                            </span>

                            <div className="d-flex gap-2">
                              <i
                                className="ri-edit-2-line text-primary"
                                style={{ cursor: "pointer" }}
                                onClick={() => handleEdit(item)}
                              ></i>

                              <i
                                className="ri-delete-bin-line text-danger"
                                style={{ cursor: "pointer" }}
                                onClick={() => handleDelete(item._id)}
                              ></i>
                            </div>

                          </div>

                          <p className="text-muted small mb-2">
                            {item.description}
                          </p>
                          {item.ingredients?.length > 0 && (
                            <div className="d-flex flex-wrap gap-1 mb-2">
                              {item.ingredients.map((ing, idx) => (
                                <span
                                  key={idx}
                                  className="px-2 py-1 rounded"
                                  style={{
                                    background: "#e7f1ff",
                                    color: "#0d6efd",
                                    fontSize: 11,
                                    fontWeight: 700,
                                    letterSpacing: 0.4
                                  }}
                                >
                                  {ing.inventoryId?.name?.toUpperCase()} – {ing.qty}
                                </span>
                              ))}
                            </div>
                          )}
                          {item.menuGroup === "bar" ? (

                            <div className="small mb-2">

                              <div className="fw-bold">
                                Selling Price ₹{item.priceFull}
                              </div>

                              <div>Bottle Cost: ₹{item.foodCost}</div>


                              {/* shot prices */}
                              {item.sizes?.map((s, i) => (
                                <div key={i}>
                                  {s.size} — ₹{s.price}
                                </div>
                              ))}

                            </div>

                          ) : (

                            <div className="d-flex justify-content-between small">
                              <span>Full ₹{item.priceFull}</span>
                              <span>Half ₹{item.priceHalf || "-"}</span>
                            </div>

                          )}

                          {item.preparationTime > 0 && (
                            <div className="small text-muted">
                              ⏱ Prep Time: {item.preparationTime} mins
                            </div>
                          )}

                          {item.menuGroup === "restaurant" && (
                            <>
                              <div className="small text-muted mt-2">
                                Food Cost: ₹{item.foodCost}
                              </div>

                              <div className="small">
                                Margin: ₹{item.margin?.amount}
                                <span className="text-success ms-1">
                                  ({item.margin?.percent}%)
                                </span>
                              </div>
                            </>
                          )}
                        </CardBody>
                      </Card>
                    </Col>
                  ))}
              </Row>
            )}
          </CardBody>
        </Card>

        {/* ================= DRAWER ================= */}

        <Offcanvas
          isOpen={drawerOpen}
          toggle={() => setDrawerOpen(false)}
          direction="end"
          style={{ width: 420 }}
        >
          <OffcanvasHeader toggle={() => setDrawerOpen(false)}>
            Add Menu Item
          </OffcanvasHeader>

          <OffcanvasBody>

            {/* ================= IMAGE ================= */}
            <div className="mb-3 text-center">
              <img
                src={
                  form.imageUrl ||
                  "https://via.placeholder.com/300x180?text=Upload+Image"
                }
                alt="preview"
                className="img-fluid rounded mb-2"
                style={{ height: 180, objectFit: "cover", width: "100%" }}
              />

              <Label>Image URL</Label>
              <Input
                placeholder="https://example.com/image.jpg"
                value={form.imageUrl}
                onChange={(e) =>
                  setForm({ ...form, imageUrl: e.target.value })
                }
              />
            </div>

            {/* ================= NAME ================= */}
            <div className="mb-3">
              <Label>{menuGroup === "bar" ? "Drink Name" : "Item Name"}</Label>
              <Input
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
              />
            </div>

            {/* ================= CATEGORY ================= */}
            <div className="mb-3">
              <Label>Category</Label>
              <Input
                type="select"
                value={form.category}
                onChange={(e) =>
                  setForm({ ...form, category: e.target.value })
                }
              >
                <option value="">Select</option>
                {categories.map((cat) => (
                  <option key={cat._id} value={cat._id}>
                    {cat.name}
                  </option>
                ))}
              </Input>
            </div>

            {/* ================================================= */}
            {/* ================= BAR MODE ====================== */}
            {/* ================================================= */}

            {menuGroup === "bar" && (

              <>

                <div className="mb-3">
                  <Label>Sub-Category</Label>
                  <Input
                    type="text"
                    value={form.type}
                    onChange={(e) =>
                      setForm({ ...form, type: e.target.value })
                    }
                  >

                  </Input>
                </div>

                <Label className="fw-bold">Drink Sizes & Prices</Label>

                {form.sizes?.map((s, idx) => (
                  <div key={idx} className="d-flex gap-2 mb-2">

                    <Input
                      placeholder="Size (30ml)"
                      value={s.size}
                      onChange={(e) =>
                        updateBarSize(idx, "size", e.target.value)
                      }
                    />

                    <Input
                      type="number"
                      placeholder="Price"
                      value={s.price}
                      onChange={(e) =>
                        updateBarSize(idx, "price", e.target.value)
                      }
                    />

                    <Button
                      size="sm"
                      color="danger"
                      onClick={() => removeBarSize(idx)}
                    >
                      ✕
                    </Button>
                  </div>
                ))}

                <Button size="sm" color="primary" onClick={addBarSize}>
                  + Add Size
                </Button>

                {/* ✅ BAR PROFIT PREVIEW */}

                {barPreview && (
                  <Card className="mt-3 border-success">
                    <CardBody style={{ background: "#f6fffa" }}>
                      <div className="fw-bold text-success mb-2">
                        📊 Bottle Profit Preview
                      </div>

                      <div className="small">
                        Shots per bottle: {barPreview.shots}
                      </div>

                      <div className="small">
                        Bottle Sell Price: ₹{barPreview.revenue}
                      </div>

                      <div className="small">
                        Cost: ₹{barPreview.cost}
                      </div>

                      <div className="small fw-bold">
                        Margin: ₹{barPreview.margin}
                      </div>
                    </CardBody>
                  </Card>
                )}


                <Row className="mb-3">
                  <Col>
                    <Label>Bottle Cost</Label>
                    <Input
                      type="number"
                      value={form.bottleCost || ""}
                      onChange={(e) =>
                        setForm({ ...form, bottleCost: e.target.value })
                      }
                    />
                  </Col>

                  <Col>
                    <Label>Shot Size ML</Label>
                    <Input
                      type="number"
                      value={form.shotSizeML || ""}
                      onChange={(e) =>
                        setForm({ ...form, shotSizeML: e.target.value })
                      }
                    />
                  </Col>
                </Row>

                <div className="mb-3">
                  <Label>Overhead Cost</Label>
                  <Input
                    type="number"
                    value={form.overheadCost || 100}
                    onChange={(e) =>
                      setForm({ ...form, overheadCost: e.target.value })
                    }
                  />
                </div>

              </>
            )}

            {/* ================================================= */}
            {/* ================= RESTAURANT MODE =============== */}
            {/* ================================================= */}

            {menuGroup === "restaurant" && (
              <>
                {/* TYPE */}
                <div className="mb-3">
                  <Label>Type</Label>
                  <Input
                    type="select"
                    value={form.type}
                    onChange={(e) =>
                      setForm({ ...form, type: e.target.value })
                    }
                  >
                    <option value="">Select</option>
                    <option>Veg</option>
                    <option>Non-Veg</option>
                  </Input>
                </div>

                {/* INGREDIENTS */}
                <div className="mb-3">
                  <Label>Ingredients</Label>

                  {form.ingredients?.map((ing, idx) => (
                    <div key={idx} className="d-flex gap-2 mb-1 align-items-center">

                      <select
                        className="form-select"
                        value={ing.inventoryId}
                        onChange={(e) => {
                          const updated = [...form.ingredients];
                          updated[idx].inventoryId = e.target.value;
                          setForm({ ...form, ingredients: updated });
                        }}
                      >
                        <option value="">Select Product</option>

                        {inventory.map((item) => (
                          <option key={item._id} value={item._id}>
                            {item.name} ({item.unit})
                          </option>
                        ))}
                      </select>

                      <input
                        type="number"
                        placeholder="Qty"
                        value={ing.qty}
                        onChange={(e) => {
                          const updated = [...form.ingredients];
                          updated[idx].qty = Number(e.target.value);
                          setForm({ ...form, ingredients: updated });
                        }}
                        className="form-control"
                        style={{ width: 120 }}
                      />

                      <button
                        type="button"
                        className="btn btn-danger btn-sm"
                        onClick={() => {
                          const updated = [...form.ingredients];
                          updated.splice(idx, 1);
                          setForm({ ...form, ingredients: updated });
                        }}
                      >
                        ❌
                      </button>
                    </div>
                  ))}
                  <button
                    type="button"
                    className="btn btn-primary btn-sm mt-1"
                    onClick={() =>
                      setForm({
                        ...form,
                        ingredients: [
                          ...(form.ingredients || []),
                          { inventoryId: "", qty: 0 }
                        ],
                      })
                    }
                  >
                    + Add Ingredient
                  </button>
                </div>

                {/* PRICES */}
                <Row>
                  <Col md={6}>
                    <Label>Full Price</Label>
                    <Input
                      value={form.priceFull}
                      onChange={(e) =>
                        setForm({ ...form, priceFull: e.target.value })
                      }
                    />
                  </Col>

                  <Col md={6}>
                    <Label>Half Price</Label>
                    <Input
                      value={form.priceHalf}
                      onChange={(e) =>
                        setForm({ ...form, priceHalf: e.target.value })
                      }
                    />
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col md={12}>
                    <Label>Preparation Time (Minutes)</Label>
                    <Input
                      type="number"
                      placeholder="e.g. 20"
                      value={form.preparationTime}
                      onChange={(e) =>
                        setForm({ ...form, preparationTime: e.target.value })
                      }
                    />
                  </Col>
                </Row>
              </>
            )}

            {/* ================= DESCRIPTION ================= */}
            <div className="mb-3 mt-3">
              <Label>Description</Label>
              <Input
                type="textarea"
                value={form.description}
                onChange={(e) =>
                  setForm({ ...form, description: e.target.value })
                }
              />
            </div>

            {/* ================= STATUS ================= */}
            <div className="mt-3">
              <Label>Status</Label>
              <Input
                type="select"
                value={form.status}
                onChange={(e) =>
                  setForm({ ...form, status: e.target.value })
                }
              >
                <option>Active</option>
                <option>Inactive</option>
              </Input>
            </div>

            {/* ================= ACTIONS ================= */}
            <div className="d-flex gap-2 mt-4">
              <Button color="primary" onClick={handleSave}>
                Save
              </Button>
              <Button color="light" onClick={() => setDrawerOpen(false)}>
                Cancel
              </Button>
            </div>

          </OffcanvasBody>

        </Offcanvas>
          {/* ==============================
        CREATE CATEGORY MODAL
    ============================== */}

    {renderCategoryModal()}
      </Container>
    </div>
  );
};

export default MenuBuilder;
